import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { QuestionCircleFilled } from '@ant-design/icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'src/components/Antd';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { Uploader, useSingleImageEffect } from 'src/components/Upload';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import {
  EnumCollapseId,
  getCollapse,
  getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare,
  onCollapseChange,
  onMiniProgramShareChange,
} from 'src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageEditor/slice';
import css from './css.module.less';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const Mini = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const d = useDispatch();
  const share = useSelector(getGeneralMiniProgramShare()) || {};
  const info = useSelector(getGeneralMiniProgramPageInfo()) || {};
  const { shareCoverImage, shareTitle } = share;
  const { miniProgramPath, miniProgramAppId, miniProgramQRCode } = info;
  const [fileList, setFileList] = React.useState(
    shareCoverImage ? [shareCoverImage] : [],
  );
  useSingleImageEffect(shareCoverImage, fileList, setFileList);

  const handleImageChange = (list: Array<any>) => {
    const length = list.length;
    const image = length ? list[length - 1] : null;
    setFileList(list);
    d(onMiniProgramShareChange({ shareCoverImage: image }));
  };

  const handleTextChange = (text) => {
    d(onMiniProgramShareChange({ shareTitle: text }));
  };

  return (
    <SectionContent className={css.container}>
      <Section bottomBorder>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n('legalPage.index.shareCoverImage')}
                  bottomTitle={getI18n(
                    'legalPage.index.shareCoverImageBottomTitle',
                  )}>
                  <Uploader
                    width={180}
                    height={180}
                    multiple={false}
                    fileList={fileList}
                    onChange={handleImageChange}
                  />
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n('legalPage.index.shareTitle')}
                  rightPart={
                    <CountWords
                      count={(shareTitle || '').length}
                      allCount={100}
                    />
                  }>
                  <Input
                    // error={(textErr || []).length > 0}
                    // help={(textErr || []).join(' ')}
                    size={'large'}
                    // className={css.input}
                    placeholder={getI18n('legalPage.index.shareTitle')}
                    maxLength={100}
                    fullyControlledFilter={(v) => v}
                    value={shareTitle}
                    onChange={handleTextChange}
                  />
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </Section>
      <Section>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={
                    <div>
                      <span className={css.name}>
                        {getI18n('legalPage.index.miniProgramPath')}
                      </span>
                      <WhiteBackgroundTooltip
                        title={
                          <TooltipContainer>
                            <TooltipTitle>
                              {getI18n('legalPage.index.miniProgramPath')}
                            </TooltipTitle>
                            <TooltipContent>
                              {getI18n('legalPage.index.miniProgramPathDesc')}
                            </TooltipContent>
                          </TooltipContainer>
                        }
                        placement='rightTop' //overlayClassName
                      >
                        <QuestionCircleFilled rev className={css.icon} />
                      </WhiteBackgroundTooltip>
                    </div>
                  }>
                  {miniProgramPath || '-'}
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper
                  title={
                    <div>
                      <span className={css.name}>
                        {getI18n('legalPage.index.miniProgramAppID')}
                      </span>
                      <WhiteBackgroundTooltip
                        title={
                          <TooltipContainer>
                            <TooltipTitle>
                              {getI18n('legalPage.index.miniProgramAppID')}
                            </TooltipTitle>
                            <TooltipContent>
                              {getI18n('legalPage.index.miniProgramAppIDDesc')}
                            </TooltipContent>
                          </TooltipContainer>
                        }
                        placement='rightTop' //overlayClassName
                      >
                        <QuestionCircleFilled rev className={css.icon} />
                      </WhiteBackgroundTooltip>
                    </div>
                  }>
                  {miniProgramAppId || '-'}
                </ItemWrapper>
              ),
            },
          ]}
        />
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={
                    <div>
                      <span className={css.name}>
                        {getI18n('legalPage.index.miniProgramQRCode')}
                      </span>

                      <WhiteBackgroundTooltip
                        // visible
                        title={
                          <TooltipContainer>
                            <TooltipTitle>
                              {getI18n('legalPage.index.miniProgramQRCode')}
                            </TooltipTitle>
                            <TooltipContent>
                              {getI18n('legalPage.index.miniProgramQRCodeDesc')}
                            </TooltipContent>
                          </TooltipContainer>
                        }
                        placement='rightTop' //overlayClassName
                      >
                        <QuestionCircleFilled rev className={css.icon} />
                      </WhiteBackgroundTooltip>
                    </div>
                  }>
                  {miniProgramQRCode ? (
                    <div className={css.download}>
                      {getI18n('legalPage.index.download')}
                    </div>
                  ) : (
                    '-'
                  )}
                </ItemWrapper>
              ),
            },
            {
              child: <React.Fragment />,
            },
          ]}
        />
      </Section>
    </SectionContent>
  );
};
export default SectionHOC(Mini, {
  id: EnumCollapseId.MiniProgramShare,
  title: getI18nFromGeneral('general.hOCTitle.miniProgramShare'),
  getCollapse,
  onCollapseChange,
});
